import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Youtube } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import skillsetLogo from '../assets/skillset-logo.png'; // лого Skillset
import siteLogo from '../assets/logo.png'; // логотип сайта
import TikTokLogo from '../assets/tiktok.png'; // <-- тт



const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center space-x-3 mb-6">
              <img 
                src={siteLogo} 
                alt="Steppe Rise" 
                className="h-10 w-auto"
              />
              <div className="flex items-center space-x-2 ml-4">
                <span className="text-gray-400 text-sm">Powered by</span>
                <img 
                  src={skillsetLogo} 
                  alt="Skillset" 
                  className="h-4 w-auto"
                />
              </div>
            </Link>
            <p className="text-gray-300 mb-6 max-w-md">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/stepperise/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="p-2 bg-gray-800 rounded-lg hover:bg-yellow-600 transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://tiktok.com/@stepperise_kz"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-gray-800 rounded-lg hover:bg-yellow-600 transition-colors"
              >
                <img src={TikTokLogo} alt="TikTok" className="h-5 w-5" />
              </a>
              <a 
                href="https://www.youtube.com/@SteppeRise" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="p-2 bg-gray-800 rounded-lg hover:bg-yellow-600 transition-colors"
              >
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-yellow-400">
              {t('footer.quickLinks.title')}
            </h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-yellow-400 transition-colors">{t('footer.quickLinks.home')}</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-yellow-400 transition-colors">{t('footer.quickLinks.about')}</Link></li>
              <li><Link to="/register" className="text-gray-300 hover:text-yellow-400 transition-colors">{t('footer.quickLinks.register')}</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-yellow-400 transition-colors">{t('footer.quickLinks.contact')}</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-yellow-400">
              {t('footer.contact.title')}
            </h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-gray-300">
                <Mail className="h-4 w-4" />
                <span>{t('footer.contact.email')}</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300">
                <Phone className="h-4 w-4" />
                <span>{t('footer.contact.phone')}</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300">
                <MapPin className="h-4 w-4" />
                <span>{t('footer.contact.location')}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
